export default function ChevronDownIcon() {
  return (
    <>
      <g id='vuesax/linear/arrow-up'>
        <g id='arrow-up'>
          <path
            id='Vector'
            d='M2.72076 5.96657L7.06743 10.3132C7.58076 10.8266 8.42076 10.8266 8.9341 10.3132L13.2808 5.96658'
            strokeWidth='1.47473'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </>
  );
}
